import { AllocateSingleId } from "../../AllocateId";
import { GetMasterTableEntries } from "../../GetMasterTableEntries";
import { DeleteFromServer, FetchFromServer, SaveToServer } from "../../Post";

const MasterTableName = "GAAProjectSpaceGroupMaster";
const FetchRequestType = "GAAProjectSpaceGroupFetchRequest";

export const GetProjectSpaceGroup = async (Ref) => {
  let payload = { GAAProjectSpaceGroupRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};

export const SaveProjectSpaceGroup = async (ref, payload) => {
  payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, []);
};

export const GetProjectSpaceGroupList = async () => {
  let payload = { ProjectSpaceGroupRefs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  result = result.sort((a, b) => a.Name.localeCompare(b.Name));
  return result;
};

export const DeleteProjectSpaceGroup = async (payload) => {
  return await DeleteFromServer(payload, MasterTableName);
};

export const GetSpaceGroupListByProject = async (projectRef) => {
  let payload = { GAAProjectRefs: [projectRef] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  return result;
};

